function initSizePopoverFlip(popover) {
  if (popover.dataset.flipInitialized) return; // Avoid double-init
  popover.dataset.flipInitialized = 'true';

  const button = popover.previousElementSibling;
  if (!button) return;

  const isMobilePopover = () => {
    // Match the theme's mobile breakpoint exactly
    return window.matchMedia("(max-width: 999px)").matches;
  };

  const updatePlacement = () => {
    const rect = button.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < 300 && spaceAbove > spaceBelow) {
      popover.classList.add('is-flipped');
    } else {
      popover.classList.remove('is-flipped');
    }
  };

  let isOpen = false;

  const openHandler = () => {
    setTimeout(() => {
     if (isMobilePopover()) {
        popover.classList.remove('is-flipped');
        return;
      }

      updatePlacement();

      if (!isOpen) {
        window.addEventListener('scroll', updatePlacement, { passive: true });
        window.addEventListener('resize', updatePlacement);
        isOpen = true;
      }
    }, 50);
  };

  button.addEventListener('click', openHandler);

  popover.addEventListener('close', () => {
    window.removeEventListener('scroll', updatePlacement);
    window.removeEventListener('resize', updatePlacement);
    isOpen = false;
  });
}

// 1. Run on already-present popovers (e.g., rendered inline on page load)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('x-popover.size_popover').forEach((popover) => {
    initSizePopoverFlip(popover);
  });
});

// 2. Watch for dynamically added popovers (e.g., rendered via JS or teleport)
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;

      if (node.tagName === 'X-POPOVER' && node.classList.contains('size_popover')) {
        initSizePopoverFlip(node);
      }

      // Check children in case they're wrapped in fragments or containers
      node.querySelectorAll?.('x-popover.size_popover').forEach((found) => {
        initSizePopoverFlip(found);
      });
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
